

      
import React, { useContext, useState } from 'react';
import { Navbar, Nav, Container, NavDropdown, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import vinirjiLogo from '../assets/vinirji/logo1.jpeg';
import '../styles/Navbar.css';
import { StoreContext } from '../context/StoreContext.jsx';
import { FaMobileAlt } from 'react-icons/fa';

const AppNavbar = () => {
    const { cart, logout, user, token } = useContext(StoreContext);
    const isLoggedIn = !!user && !!token;
    const location = useLocation();

    // ✅ Added collapse control
    const [expanded, setExpanded] = useState(false);
    const closeNavbar = () => setExpanded(false);

    const handleLogout = () => {
        logout();
        closeNavbar(); // ✅ close after logout
    };

    const getTotalCartItems = () => {
        if (!cart || !cart.items) return 0;
        return cart.items.reduce((total, item) => total + item.quantity, 0);
    };

    const renderDownloadAppTooltip = (props) => (
        <Tooltip id="download-app-tooltip" {...props}>
            Download App
        </Tooltip>
    );

    return (
        <Navbar
            bg="white"
            expand="lg"
            expanded={expanded}   // ✅ added
            className="shadow-sm py-2 sticky-top"
        >
            <Container fluid className="px-lg-5 px-3">

                {/* LOGO */}
                <Navbar.Brand
                    as={Link}
                    to="/"
                    onClick={closeNavbar}  // ✅ added
                    className="p-0 d-flex align-items-center me-auto"
                >
                    <img
                        src={vinirjiLogo}
                        alt="Vinirji Logo"
                        className="navbar-logo"
                    />
                </Navbar.Brand>

                {/* TOGGLE BUTTON */}
                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    className="custom-toggler"
                    onClick={() => setExpanded(expanded ? false : true)}  // ✅ added
                />

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto align-items-center">

                        <Nav.Link
                            as={Link}
                            to="/"
                            onClick={closeNavbar}
                            className={`nav-link-custom${location.pathname === '/' ? ' active' : ''}`}
                        >
                            Home
                        </Nav.Link>

                        <Nav.Link
                            href="/vendor"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={closeNavbar}
                            className="nav-link-custom"
                        >
                            Business Partner
                        </Nav.Link>

                        <NavDropdown
                            title="Services"
                            id="services-dropdown"
                            className="nav-link-custom"
                        >
                            <NavDropdown.Item as={Link} to="/restaurants" onClick={closeNavbar}>
                                Restaurants
                            </NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/groceries" onClick={closeNavbar}>
                                Groceries
                            </NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/cloudkitchens" onClick={closeNavbar}>
                                Cloud Kitchen
                            </NavDropdown.Item>
                        </NavDropdown>

                        {/* CART LINK */}
                        <Nav.Link
                            as={Link}
                            to="/cart"
                            onClick={closeNavbar}
                            className={`nav-link-custom position-relative d-flex align-items-center ${location.pathname === '/cart' ? ' active' : ''}`}
                        >
                            <span className="me-1" style={{ fontSize: '1.25em', lineHeight: 1 }}>🛒</span>
                            <span>Cart</span>
                            {getTotalCartItems() > 0 && (
                                <span className="navbar-dot ms-1">{getTotalCartItems()}</span>
                            )}
                        </Nav.Link>

                        {!isLoggedIn ? (
                            <>
                                <Nav.Link
                                    as={Link}
                                    to="/check-order"
                                    onClick={closeNavbar}
                                    className={`nav-link-custom ${location.pathname === '/check-order' ? 'active' : ''}`}
                                >
                                    Order Status
                                </Nav.Link>

                                <Nav.Link
                                    href="/admin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={closeNavbar}
                                    className="nav-link-custom"
                                >
                                    Admin
                                </Nav.Link>

                                <Nav.Link
                                    as={Link}
                                    to="/login"
                                    onClick={closeNavbar}
                                    className="nav-link-custom"
                                >
                                    Sign In
                                </Nav.Link>
                            </>
                        ) : (
                            <>
                                <div className="orders-container">
                                    <Nav.Link
                                        as={Link}
                                        to="/my-orders"
                                        onClick={closeNavbar}
                                        className={`nav-link-custom${location.pathname === '/my-orders' ? ' active' : ''}`}
                                    >
                                        Orders
                                    </Nav.Link>

                                    <Nav.Link
                                        as={Link}
                                        to="/check-order"
                                        onClick={closeNavbar}
                                        className={`nav-link-custom order-status-link${location.pathname === '/check-order' ? ' active' : ''}`}
                                    >
                                        Order Status
                                    </Nav.Link>
                                </div>

                                <Nav.Link
                                    href="/admin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={closeNavbar}
                                    className="nav-link-custom"
                                >
                                    Admin
                                </Nav.Link>

                                <NavDropdown
                                    title="My Account"
                                    id="account-dropdown"
                                    className="nav-link-custom"
                                >
                                    <NavDropdown.Item as={Link} to="/profile" onClick={closeNavbar}>
                                        Profile
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item onClick={handleLogout} className="text-danger">
                                        Logout
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </>
                        )}

                       <OverlayTrigger
    placement="bottom"
    trigger={['hover', 'focus']}
    delay={{ show: 150, hide: 300 }}
    overlay={
        <Tooltip
            id="download-app-qr-tooltip"
            className="qr-tooltip"
            style={{ pointerEvents: 'auto' }}
        >
            <div className="qr-download-content">
                <img
                    src="/Customer App_qr-code.png"
                    alt="Scan to download Customer App"
                    className="navbar-qr"
                />

                <a
                    href="https://play.google.com/store/apps/details?id=com.vinirji.customerapp&pcampaignid=web_share"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="qr-download-link"
                >
                    Download App
                </a>
            </div>
        </Tooltip>
    }
>
    <span className="nav-link-custom d-none d-lg-block">
        <FaMobileAlt style={{ fontSize: '1.4em' }} />
    </span>
</OverlayTrigger>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default AppNavbar;
